"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ForrestJSContext", {
  enumerable: true,
  get: function get() {
    return _forrestjsProvider.ForrestJSContext;
  }
});
exports.reactRoot = exports.default = void 0;
Object.defineProperty(exports, "useForrestJS", {
  enumerable: true,
  get: function get() {
    return _forrestjsProvider.useForrestJS;
  }
});
Object.defineProperty(exports, "useGetConfig", {
  enumerable: true,
  get: function get() {
    return _forrestjsProvider.useGetConfig;
  }
});
Object.defineProperty(exports, "useGetContext", {
  enumerable: true,
  get: function get() {
    return _forrestjsProvider.useGetContext;
  }
});

var _react = _interopRequireDefault(require("react"));

var _client = require("react-dom/client");

var targets = _interopRequireWildcard(require("./targets"));

var _defaultComponent = require("./default-component");

var _forrestjsProvider = require("./forrestjs-provider");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

/**
 * @param {ForrestJSContext} ctx
 * @returns {Array.<ForrestJSExtension>}
 */
var reactRoot = function reactRoot(_ref) {
  var registerAction = _ref.registerAction,
      createExtension = _ref.createExtension,
      getConfig = _ref.getConfig,
      getContext = _ref.getContext,
      setContext = _ref.setContext,
      registerTargets = _ref.registerTargets;

  /**
   * This component renders a list of wrappers definition {component, props?} recursively
   * ending in a NULL component rendering.
   *
   * @param {} param0
   * @returns
   */
  var Root = function Root(_ref2) {
    var items = _ref2.items;
    // recursion base:
    if (!items.length) return null; // render the outermost wrapper recursively:

    var _items = _toArray(items),
        curr = _items[0],
        others = _items.slice(1);

    return /*#__PURE__*/_react.default.createElement(curr.component, _objectSpread(_objectSpread({}, curr.props || {}), {}, {
      children: /*#__PURE__*/_react.default.createElement(Root, {
        items: others
      })
    }));
  };

  registerTargets(targets);
  registerAction({
    target: '$INIT_SERVICE',
    handler: function handler() {
      // Get the root definition (component + props)
      var _createExtension$wate = createExtension.waterfall(targets.REACT_ROOT_COMPONENT, {
        component: getConfig('reactRoot.component', _defaultComponent.defaultComponent),
        props: getConfig('reactRoot.props', {})
      }),
          root = _createExtension$wate.value; // Get the wrappers definitions (component + props)


      var wrappers = createExtension.sync(targets.REACT_ROOT_WRAPPER).map(function ($) {
        return $[0];
      });
      setContext('reactRoot', {
        root: root,
        wrappers: wrappers
      });
    }
  });
  registerAction({
    target: '$START_SERVICE',
    handler: function handler(forrestJSContext) {
      var rootId = getConfig('reactRoot.target', 'root');
      var reactRoot = getContext('reactRoot.root');
      var wrappers = getContext('reactRoot.wrappers'); // Instrument the whole App with ForrestJS APIs

      var Hooks = function Hooks(props) {
        return /*#__PURE__*/_react.default.createElement(_forrestjsProvider.ForrestJSContext.Provider, _extends({}, props, {
          value: forrestJSContext
        }));
      }; // Render the application composition to the DOM:


      var items = [{
        component: Hooks
      }].concat(_toConsumableArray(wrappers), [reactRoot]); // React17
      // ReactDOM.render(<Root items={items} />, document.getElementById(rootId));
      // React18

      var container = document.getElementById(rootId);
      var root = (0, _client.createRoot)(container);
      root.render( /*#__PURE__*/_react.default.createElement(Root, {
        items: items
      }));
    }
  });
};

exports.reactRoot = reactRoot;
var _default = reactRoot;
exports.default = _default;